<template>
  <el-card class="h-full relative flex flex-col">
    <div class="h-full flex flex-col">
      <div class="flex mb-10px mr-10px flex-wrap">
        <el-input
          size="small"
          class="mr-10px !w-50 mb-10px"
          placeholder="请输入隐患描述"
          v-model="searchData.keywords"
          clearable
        ></el-input>
        <el-select
          v-model="searchData.hiddenDangerSource"
          size="small"
          class="mr-10px !w-50 mb-10px"
          placeholder="请选择隐患来源"
          clearable
        >
          <el-option
            v-for="item in hiddenSourceList"
            :key="item.value"
            :label="item.displayName"
            :value="Number(item.code)"
          ></el-option>
        </el-select>
        <el-select
          size="small"
          class="mr-10px !w-50 mb-10px"
          placeholder="请选择区域"
          v-model="searchData.areaId"
          clearable
        >
          <el-option
            v-for="item in areaList"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          ></el-option>
        </el-select>
        <el-select
          v-model="searchData.hiddenDangerlevel"
          size="small"
          class="mr-10px !w-50 mb-10px"
          placeholder="请选择隐患等级"
          clearable
        >
          <el-option
            v-for="item in hiddenLevelList"
            :key="item.value"
            :label="item.displayName"
            :value="Number(item.code)"
          ></el-option>
        </el-select>
        <el-select
          v-model="searchData.hiddenDangerCategory"
          size="small"
          class="mr-10px !w-50 mb-10px"
          placeholder="请选择隐患类别"
          clearable
        >
          <el-option
            v-for="item in hiddenCategoryList"
            :key="item.value"
            :label="item.displayName"
            :value="Number(item.code)"
          ></el-option>
        </el-select>
        <el-date-picker
          class="mr-10px mb-10px"
          v-model="datePickerValue"
          format="yyyy-MM-dd"
          size="small"
          type="daterange"
          :clearable="true"
          start-placeholder="开始时间"
          end-placeholder="结束时间"
          value-format="yyyy-MM-dd"
        >
        </el-date-picker>

        <!-- <el-select
          v-model="searchData.ownedSystemOrUnit"
          size="small"
          class="mr-10px !w-50 mb-10px"
          placeholder="请选择所属系统/机组"
          clearable
        >
          <el-option
            v-for="item in ownedSystemOrUnitList"
            :key="item.id"
            :label="item.displayName"
            :value="item.id"
          ></el-option>
        </el-select> -->

        <el-button class="mb-10px" size="small" type="primary" @click="searchList">搜索</el-button>
        <el-button class="mb-10px" size="small" @click="resetSearch">重置</el-button>
        <el-button class="mb-10px" type="primary" size="small" @click="handleEvent(null, 'create')">
          新增
        </el-button>
        <el-button
          class="mb-10px"
          size="small"
          @click="handleEvent(null, 'export')"
          :disabled="!$hasAccess('export')"
        >
          批量导出
        </el-button>

        <el-button
          class="mb-10px"
          size="small"
          @click="handleEvent(null, 'batchImport')"
          :disabled="!$hasAccess('batchImport')"
          >批量导入</el-button
        >
        <el-button
          class="mb-10px"
          size="small"
          @click="handleEvent(null, 'submit')"
          :disabled="!$hasAccess('submit')"
        >
          批量提交
        </el-button>
        <PreviewButton :menuId="menuId"></PreviewButton>
      </div>
      <div class="flex-auto h-0px">
        <el-table
          ref="table"
          :data="tableData"
          border
          class="w-full"
          :height="tableHeight"
          stripe
          v-loading="loading"
          @selection-change="handleSelection"
        >
          <el-table-column type="selection" width="50"></el-table-column>
          <el-table-column label="序号" type="index" width="50"></el-table-column>
          <el-table-column
            label="隐患描述"
            prop="hiddenDangerName"
            min-width="200"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            label="隐患等级"
            prop="hiddenDangerlevelStr"
            min-width="80"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            label="隐患类别"
            prop="hiddenDangerCategoryStr"
            min-width="160"
            show-overflow-tooltip
          ></el-table-column>

          <el-table-column
            label="所在区域"
            prop="areaStr"
            min-width="120"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            label="隐患来源"
            prop="hiddenDangerSourceStr"
            min-width="120"
            show-overflow-tooltip
          ></el-table-column>
          <!-- <el-table-column
            label="所属机组系统"
            prop="ownedSystemOrUnitText"
            min-width="120"
            show-overflow-tooltip
          ></el-table-column> -->
          <el-table-column
            label="上报状态"
            prop="reportStatusStr"
            min-width="120"
            show-overflow-tooltip
          ></el-table-column>
          <!-- <el-table-column
            label="隐患类型"
            prop="hiddenDangerTypeStr"
            min-width="120"
            show-overflow-tooltip
          ></el-table-column> -->
          <el-table-column
            label="安全检查标题"
            prop="safetyInspectionTitle"
            min-width="160"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            label="安全检查期数"
            prop="safetyInspectionPeriods"
            min-width="120"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            label="上报人"
            prop="reporterName"
            min-width="80"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column label="上报时间" prop="reportTime" show-overflow-tooltip width="180px">
            <template slot-scope="scope">
              {{
                scope.row.reportTime
                  ? dayjs(scope.row.reportTime).format('YYYY-MM-DD HH:mm:ss')
                  : ''
              }}
            </template>
          </el-table-column>
          <!-- 上报状态（0：待提交，1：已提交，2：被驳回） -->
          <el-table-column label="操作" fixed="right" width="260">
            <template slot-scope="scope">
              <el-button
                :disabled="!($hasAccess('submit') && scope.row.reportStatus !== 1)"
                @click.stop="handleEvent(scope.row, 'submit')"
                size="mini"
                >提交</el-button
              >
              <el-button
                size="mini"
                @click.native="handleEvent(scope.row, 'read')"
                :disabled="!$hasAccess('read')"
                >查看</el-button
              >
              <el-button
                size="mini"
                :disabled="!($hasAccess('update') && scope.row.reportStatus !== 1)"
                @click="handleEvent(scope.row, 'update') && isCreator(scope.row)"
                >编辑</el-button
              >
              <el-button
                :disabled="!($hasAccess('delete') && scope.row.reportStatus !== 1)"
                size="mini"
                @click.stop="handleEvent(scope.row, 'delete')"
                >删除</el-button
              >
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          background
          @size-change="searchList"
          @current-change="findList"
          :current-page.sync="pageNo"
          :page-size.sync="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :page-sizes="[15, 30, 45, 60, 75, 90]"
          :total="total"
          class="float-right mt-20px ml-10px"
        ></el-pagination>
      </div>
    </div>

    <HiddenListForm
      v-if="formDialog"
      :formProps="formProps"
      :FormData="FormData"
      @refreshList="findList()"
      @cancel="handleCancel"
    />
    <HiddenListDetail
      v-if="detailDialog"
      :FormData="FormData"
      :formProps="formProps"
      @refreshList="findList()"
      @cancel="detailDialog = false"
    ></HiddenListDetail>
    <wiz-upload-file
      v-dialogDrag
      :uploadFileProps="uploadFileProps"
      @exportTemplate="exportTemplate"
      @importTemplate="importTemplate"
      @exportResults="exportResults"
    ></wiz-upload-file>
    <SelecWorkFlowtUser
      v-if="selectUserVisible"
      :isMultiple="true"
      nodeName="隐患一级审批"
      formLabel="隐患审核人"
      type="hiddenList"
      :visible.sync="selectUserVisible"
      @selected="saveUserToApprove"
    ></SelecWorkFlowtUser>
  </el-card>
</template>

<script>
import { HiddenDangerRectificationChecklistApi } from '@wiz-api/double-prevention-management'
import dayjs from 'dayjs'
import { AreaApi } from '@wiz-api/area-management'
import { wizUploadFile } from '@wiz-core/compts'
import { FileApi } from '@wiz-api/file-management'
import qs from 'qs'
import utils from '@/components/safety/enumField/utils'
import DownResultFile from '@/assets/js/safety/DownResultFile'
import PreviewButton from '@/components/previewButton/PreviewButton'
import HiddenListDetail from '../../components/HiddenList/HiddenListDetail'
import HiddenListForm from '../../components/HiddenList/HiddenListForm'

const SelecWorkFlowtUser = () => {
  return import('../../components/HiddenVerify/SelecWorkFlowtUser.vue')
}

const fileApi = new FileApi()

const areaApi = new AreaApi()

const hiddenDangerRectificationChecklistApi = new HiddenDangerRectificationChecklistApi()

export default {
  name: 'check-plan',
  mixins: [DownResultFile],
  components: {
    HiddenListDetail,
    HiddenListForm,
    wizUploadFile,
    SelecWorkFlowtUser,
    PreviewButton,
  },
  data() {
    return {
      selectUserVisible: false,
      areaList: [],
      hiddenCategoryList: [],
      hiddenTypeList: [],
      hiddenLevelList: [],
      hiddenSourceList: [],
      ownedSystemOrUnitList: [],

      uploadFileProps: {
        visible: false, // 是否开启弹窗
        active: 0, // 目前状态页面0为下载模板 1为上传模板 2为完成
        btnLoading: false, // 按钮加载状态
        isTestAndVerify: true, // 是否开启校验格式
        type: ['zip'], // 检验文件格式，为数组可传多种同类型格式
        successCount: 0, // 上传成功条数
        failureCount: 0, // 上传失败条数
        resultFile: '', // 导入结果id，下载导入结果时需要使用
      },

      FormData: {
        hiddenDangerSource: 1,
      },
      formDialog: false,
      detailDialog: false,
      datePickerValue: [],
      id: '',
      formProps: {
        title: '新增隐患排查计划',
        visible: false,
        // create 新增 update 编辑 read 详情
        editType: 'create',
      },
      // 作业活动清单
      tableData: [],
      loading: false,
      searchData: {},
      total: 0,
      pageNo: 1,
      pageSize: 15,
      selectionData: [],
    }
  },
  computed: {
    tableHeight() {
      return 'calc(100% - 54px)'
    },
    isCreator() {
      return (row) => {
        return true
      }
    },
    pageTags() {
      return this.$store.getters['System/pageTags']
    },
    menuId() {
      return window?.wiz?._route?.meta?.Id ? wiz._route.meta.Id : ''
    },
  },
  created() {
    // 排查治理跳转隐患上报
    const params = this.$route.params
    if (params.id) {
      this.handleEvent(params, 'create')
    }
    const id = this.$route.query.id
    // 待办-核实
    if (id && this.$route.query.mode) {
      this.initDialog({ id }, this.$route.query.mode === 'approve' ? 'update' : 'read')
    }
    utils.getDataCategory(
      [
        'DoublePreventionManagement.DataCategory.HiddenSource',
        'DoublePreventionManagement.DataCategory.HiddenLevel',
        'DoublePreventionManagement.DataCategory.HiddenType',
        'DoublePreventionManagement.DataCategory.HiddenCategory',
        'DoublePreventionManagement.DataCategory.OwnedSystemOrUnit',
      ],
      [
        'hiddenSourceList',
        'hiddenLevelList',
        'hiddenTypeList',
        'hiddenCategoryList',
        'ownedSystemOrUnitList',
      ],
      this
    )
    this.searchList()
    this.getAreaList()
  },
  watch: {
    datePickerValue(list) {
      if (list && list.length) {
        this.searchData.reportTimeStart = dayjs(list[0]).format('YYYY-MM-DD HH:mm:ss')
        this.searchData.reportTimeEnd = dayjs(list[1]).format('YYYY-MM-DD HH:mm:ss')
      } else {
        this.searchData.reportTimeStart = ''
        this.searchData.reportTimeEnd = ''
      }
    },
  },
  methods: {
    saveUserToApprove(ids) {
      if (!this.currentSubmitRow) {
        if (!this.selectionData || this.selectionData.length === 0) {
          this.$message({
            showClose: true,
            message: '请勾选要提交的隐患',
            type: 'warning',
          })
        }
        const isSubmit = this.selectionData.every((item) => {
          return item.reportStatus === 0
        })
        if (!isSubmit) {
          this.$message({
            showClose: true,
            message: '请不要勾选已经提交过的隐患',
            type: 'warning',
          })
          return
        }
        this.$confirm('请确认是否批量提交隐患？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(async () => {
            this.loading = true
            const promiseAll = this.selectionData.map((item) => {
              return hiddenDangerRectificationChecklistApi.hiddenDangersReporteSubmit({
                body: {
                  id: item.id,
                  receiverIds: ids,
                },
              })
            })
            Promise.all(promiseAll)
              .then((res) => {
                this.loading = false
                this.$message.success('提交成功')
                this.findList()
              })
              .catch(() => {
                this.loading = false
              })
          })
          .catch(() => {})
        return
      }
      this.$confirm('请确认是否提交该隐患？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(async () => {
          this.loading = true
          const [err, res] = await hiddenDangerRectificationChecklistApi.hiddenDangersReporteSubmit(
            {
              body: {
                id: this.currentSubmitRow.id,
                receiverIds: ids,
              },
            }
          )
          if (!err) {
            this.$message.success('提交成功')
            this.findList()
          } else {
            this.loading = false
          }
        })
        .catch(() => {})
    },
    async handleCancel() {
      if (this.$route.query.id) {
        if (this.pageTags && this.pageTags.length > 1) {
          await this.$store.dispatch(
            'System/pageTags',
            _.filter(this.pageTags, (i) => {
              return i.path !== this.$route.path
            })
          )
        }
        this.$router.go(-1)
      }
      this.formDialog = false
    },
    searchList() {
      this.pageNo = 1
      this.findList()
    },
    resetSearch() {
      this.searchData = this.$options.data()
      this.datePickerValue = []
      this.searchList()
    },
    // 选中
    handleSelection(values) {
      // this.selectionData = values.map((item) => {
      //   return item.id
      // })
      this.selectionData = values
    },
    async findList() {
      this.loading = true
      const searchData = utils.deleteFormField(this.searchData)
      const data = {
        skipCount: (this.pageNo - 1) * this.pageSize,
        maxResultCount: this.pageSize,
        ...searchData,
        reportStatus: [0, 2], // 0=待提交  2=被驳回
      }
      // 低代码
      if (window.__POWERED_BY_QIANKUN__) {
        const instance = axios.create()
        instance.defaults.baseURL = Wiz.globalSettings.api.endpoints.default
        const token = localStorage.getItem('authorization')
        instance.defaults.headers.common.Authorization = `Bearer ${token}`
        const res1 = await instance.get(
          `/api/double-prevention-management/hidden-danger-rectification-checklists/paged-list-query?${qs.stringify(
            data
          )}`
        )
        if (res1.status === 200 && res1.data) {
          this.tableData = res1.data.items
          this.total = res1.data.totalCount
          this.loading = false
        }
        return
      }
      const [err, res] = await hiddenDangerRectificationChecklistApi.pagedListQuery(data)
      if (!err) {
        this.tableData = res.items
        this.total = res.totalCount
        this.loading = false
      }
    },
    refreshList() {
      this.findList()
    },
    // 列表操作-事件
    handleEvent(row = null, operation) {
      switch (operation) {
        case 'delete':
          this.$confirm('请确认是否删除隐患？', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
          })
            .then(async () => {
              const [err, res] = await hiddenDangerRectificationChecklistApi.callDelete(row.id)
              if (!err) {
                this.$message.success('删除成功')
                this.findList()
              }
            })
            .catch(() => {})
          break
        case 'create':
          this.initDialog(row, operation)
          break
        case 'read':
          this.initDialog(row, operation)
          break
        case 'update':
          this.initDialog(row, operation)
          break
        case 'completionStatus':
          this.initDialog(row, operation)
          break
        case 'submit':
          this.selectUserVisible = true
          this.currentSubmitRow = row
          break
        case 'batchImport':
          this.uploadFileProps.active = 0
          this.uploadFileProps.visible = true
          break
        case 'export':
          // if (!this.selectionData || this.selectionData.length === 0) {
          //   this.$message({
          //     showClose: true,
          //     message: '请勾选要导出的记录',
          //     type: 'warning',
          //   })
          //   return
          // }
          this.export()
          break
        default:
          break
      }
    },
    async exportResults() {
      const [err, res] = await fileApi.download(this.uploadFileProps.resultFile, {
        returnType: 'Blob',
      })
      if (!err) {
        this.downLoadExcel('导入结果', res, 'excel')
      }
    },
    // 下载模板
    async exportTemplate() {
      const [err, res] = await hiddenDangerRectificationChecklistApi.hiddenDangersExcelTemplateFile(
        {
          returnType: 'Blob',
        }
      )
      if (!err) {
        this.downLoadExcel('隐患清单模板', res, 'zip')
        this.$message({
          showClose: true,
          message: '模板下载成功',
          type: 'success',
        })
      }
    },
    // 上传文件
    async importTemplate(file) {
      this.uploadFileProps.btnLoading = true
      const formData = new FormData()
      _.forIn({ file }, (value, key) => {
        formData.append('input', value)
      })
      const [err, res] = await hiddenDangerRectificationChecklistApi.hiddenDangersExcelFile({
        input: formData.get('input'),
      })
      if (!err) {
        if (res.code === 1) {
          this.uploadFileProps.successCount = res.data?.numberSuccesses
          this.uploadFileProps.failureCount = res.data?.numberFailures
          // 如需兼容老样式，则resultFile字段为空或者不设置皆可
          this.uploadFileProps.resultFile = res.data?.fileId
          this.uploadFileProps.active = 2
          this.resetSearch()
        } else {
          this.$message({
            duration: 10000,
            showClose: true,
            message: res.msg,
            type: 'error',
          })
        }
      }
      this.uploadFileProps.btnLoading = false
    },
    async export() {
      const [err, res] =
        await hiddenDangerRectificationChecklistApi.hiddenDangersReporteExportToExcelFile({
          hiddenDangersReporteIds: this.selectionData.map((item) => {
            return item.id
          }),
          returnType: 'Blob',
        })
      if (!err) {
        this.downLoadExcel('隐患清单数据', res, 'excel')
        this.$message({
          showClose: true,
          message: '导出成功',
          type: 'success',
        })
      }
    },
    // 文件流下载
    downLoadExcel(fileName = '下载文件', data, type) {
      const fileType = {
        zip: 'application/zip',
        excel: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      }
      const blob = new Blob([data], {
        type: fileType[type],
      })
      const link = document.createElement('a')
      link.href = window.URL.createObjectURL(blob)
      link.download = `${fileName}`
      link.click()
      window.URL.revokeObjectURL(link.href)
    },
    async initDialog(row, operation) {
      // 没有新增获取数据
      this.formProps.editType = operation
      this.formProps.title = `${
        // eslint-disable-next-line no-nested-ternary
        operation === 'create' ? '新增' : operation === 'update' ? '编辑' : '查看'
      }隐患信息`
      if (operation === 'create') {
        this.FormData = this.$options.data().FormData
        if (row && row.id) {
          this.FormData = row
        }
      } else {
        let resVal = {}
        if (window.__POWERED_BY_QIANKUN__) {
          // 低代码
          const instance = axios.create()
          instance.defaults.baseURL = Wiz.globalSettings.api.endpoints.default
          const token = localStorage.getItem('authorization')
          instance.defaults.headers.common.Authorization = `Bearer ${token}`
          const result = await instance.get(
            `/api/double-prevention-management/hidden-danger-rectification-checklists/${row.id}`
          )
          if (result.status === 200 && result.data) {
            resVal = result.data
          }
        } else {
          const [err, res] = await hiddenDangerRectificationChecklistApi.get(row.id)
          if (!err) {
            resVal = res
          }
        }
        if (row.workflowTaskId) {
          resVal.workflowTaskId = row.workflowTaskId
        }
        if (row.currentWorkflowTaskId) {
          resVal.currentWorkflowTaskId = row.currentWorkflowTaskId
        }
        if (row.currentWorkflowDelayTaskId) {
          resVal.currentWorkflowDelayTaskId = row.currentWorkflowDelayTaskId
        }
        if (resVal.ownedSystemOrUnit) {
          resVal.ownedSystemOrUnit = resVal.ownedSystemOrUnit.split(',')
        }
        this.FormData = resVal
      }
      if (operation === 'read') {
        this.detailDialog = true
      } else {
        this.formDialog = true
      }
    },
    // 获取区域列表
    async getAreaList() {
      const [err, res] = await areaApi.getList({
        skipCount: 0,
        maxResultCount: 999,
      })
      if (!err) {
        this.areaList = res.items || []
      }
    },
  },
}
</script>

<style scoped lang="scss">
::v-deep .el-card__body {
  height: 100%;
}
</style>
